// Survivorship config / weighted trust (PRE-2286, PRE-1170) — one ruleset per schema,
// authored from the golden dataset's screens, consumed by the dedup merge engine.
export const GET_SURVIVORSHIP_RULESET_REQUEST = "GET_SURVIVORSHIP_RULESET_REQUEST";
export const GET_SURVIVORSHIP_RULESET_SUCCESS = "GET_SURVIVORSHIP_RULESET_SUCCESS";
export const GET_SURVIVORSHIP_RULESET_FAILURE = "GET_SURVIVORSHIP_RULESET_FAILURE";

export const SAVE_SURVIVORSHIP_RULESET_REQUEST = "SAVE_SURVIVORSHIP_RULESET_REQUEST";
export const SAVE_SURVIVORSHIP_RULESET_SUCCESS = "SAVE_SURVIVORSHIP_RULESET_SUCCESS";
export const SAVE_SURVIVORSHIP_RULESET_FAILURE = "SAVE_SURVIVORSHIP_RULESET_FAILURE";

// The schema's datasets (for the per-source trust sliders).
export const GET_SURVIVORSHIP_DATASETS_REQUEST = "GET_SURVIVORSHIP_DATASETS_REQUEST";
export const GET_SURVIVORSHIP_DATASETS_SUCCESS = "GET_SURVIVORSHIP_DATASETS_SUCCESS";
export const GET_SURVIVORSHIP_DATASETS_FAILURE = "GET_SURVIVORSHIP_DATASETS_FAILURE";

// GET /businessareas/:businessAreaId/schemas/:schemaId/survivorship (404 -> no ruleset yet)
export const getSurvivorshipRulesetRequest = (businessAreaId, schemaId) => ({
    type: GET_SURVIVORSHIP_RULESET_REQUEST,
    params: { businessAreaId, schemaId },
});
export const getSurvivorshipRulesetSuccess = (ruleset) => ({ type: GET_SURVIVORSHIP_RULESET_SUCCESS, payload: ruleset });
export const getSurvivorshipRulesetFailure = (error) => ({ type: GET_SURVIVORSHIP_RULESET_FAILURE, payload: error });

// PUT /businessareas/:businessAreaId/schemas/:schemaId/survivorship
export const saveSurvivorshipRulesetRequest = (businessAreaId, schemaId, ruleset) => ({
    type: SAVE_SURVIVORSHIP_RULESET_REQUEST,
    params: { businessAreaId, schemaId, ruleset },
});
export const saveSurvivorshipRulesetSuccess = (ruleset) => ({ type: SAVE_SURVIVORSHIP_RULESET_SUCCESS, payload: ruleset });
export const saveSurvivorshipRulesetFailure = (error) => ({ type: SAVE_SURVIVORSHIP_RULESET_FAILURE, payload: error });

export const getSurvivorshipDataSetsRequest = (businessAreaId, schemaId) => ({
    type: GET_SURVIVORSHIP_DATASETS_REQUEST,
    params: { businessAreaId, schemaId },
});
export const getSurvivorshipDataSetsSuccess = (dataSets) => ({ type: GET_SURVIVORSHIP_DATASETS_SUCCESS, payload: dataSets });
export const getSurvivorshipDataSetsFailure = (error) => ({ type: GET_SURVIVORSHIP_DATASETS_FAILURE, payload: error });
